export default "__VITE_ASSET__DK6BvL4C__"